<template>
  <div>加载中，请稍后...</div>
</template>

<script>
export default {
  created() {
    const id = util.getUrlParamByName("id");
    if (id) {
      console.log("存在");
      location.href = "http://cvii1314.cn:9902/report?id=" + id;
    }
  },
};
</script>

<style>
</style>